import { FC, ReactNode } from 'react';
import styled from 'styled-components';

// angular will add `.angular-modal` and `.angular-delay` classes to this element
const Dimmer = styled.div`
  z-index: 1;
  opacity: 0;
  background: #000;
  pointer-events: none;
  transition: opacity 0.15s linear; /* copied from old boostrap styles */
  transition-delay: 0s;

  &.angular-modal {
    opacity: 0.5;
    pointer-events: auto;
  }

  &.angular-delay {
    transition-delay: 0.15s; /* sometimes we need a delay */
  }
`;

// the header and footer in our React app need to be dimmed, if Angular opens a modal
export const AngularModalDimmer: FC<{
  id: string;
  children: ReactNode;
}> = ({ id, children }) => {
  return (
    <div style={{ display: 'grid' }}>
      <Dimmer style={{ gridArea: '1 / 1 / 1 / 1' }} id={id} />
      <div style={{ gridArea: '1 / 1 / 1 / 1' }}>{children}</div>
    </div>
  );
};
